// extracted by mini-css-extract-plugin
module.exports = {"dialog":"wCTPwqkecgFCqSwc4MOl","closeIcon":"ccmBpqTDrlwWcWLYHBZi"};